import { SET_LANGUAGE, SET_NETWORK } from "../actions/types";

const initialState = {
  language: "persian", // english,
  network: "live",
};

export const CommonReducer = (state = initialState, action = {}) => {
  const { type, payload } = action;
  switch (type) {
    case SET_LANGUAGE:
      return {
        language: payload,
        network: state.network,
      };
    case SET_NETWORK:
      return {
        language: state.language,
        network: payload,
      };

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./frontend/redux/reducers/CommonReducer.js